export default {
  list: {
    addUser: 'Add User',
    id: 'ID',
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    action: 'Action',
    show: 'Show',
    from: 'from',
    moreDetail: 'More Detail'
  },
  create: {
    addUser: 'Add User',
    name: 'Name',
    namePlaceholder: 'Please input name',
    email: 'Email',
    emailPlaceholder: 'Please input email',
    phone: 'Phone Number',
    phonePlaceholder: 'Please input phone number',
    password: 'Password',
    passwordPlaceholder: 'Please input Password',
    save: 'Save'
  },
  detail: {
    userInfo: 'User Info',
    id: 'ID',
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    update: 'Update',
    delete: 'Delete',
    modalTitle: 'Delete User?',
    modalDesc: 'Are you sure you want to delete this user?',
    yes: 'Yes',
    no: 'No'
  }
}
